(() => {
  const mainFor = element => [...document.querySelectorAll('maxler-protein-product')].find(main => main.dataset.productId === element.dataset.productId);
  if (!customElements.get('maxler-protein-formula')) {
    customElements.define('maxler-protein-formula', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const update = (main, variant = main?.current) => {
          const summary = main?.meta?.get(String(variant?.id))?.summary;
          this.hidden = !summary?.overview_whey_blend || !summary?.enzyme_complex;
        };
        const sync = () => update(mainFor(this));
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, {once: true, signal: this.controller.signal}); else sync();
        document.addEventListener('variantChange', event => {
          const main = event.target.closest?.('maxler-protein-product');
          if (main?.dataset.productId === this.dataset.productId) update(main, event.detail.variant);
        }, {capture: true, signal: this.controller.signal});
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  if (customElements.get('maxler-protein-nutrition')) return;
  customElements.define('maxler-protein-nutrition', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.sequence = 0;
      this.body = this.querySelector('[data-nutrition-body]');
      this.status = this.querySelector('[data-nutrition-status]');
      this.retry = this.querySelector('[data-nutrition-retry]');
      this.labels = JSON.parse(this.querySelector('[data-nutrition-labels]').textContent);
      this.cache = new Map([[this.dataset.variantId, this.body.innerHTML]]);
      this.retry.addEventListener('click', () => this.update(this.requestedId), {signal: this.controller.signal});
      document.addEventListener('variantChange', event => {
        const main = event.target.closest?.('maxler-protein-product');
        if (main?.dataset.productId !== this.dataset.productId || !Object.hasOwn(event.detail || {}, 'variant')) return;
        this.update(event.detail.variant?.id);
      }, {capture: true, signal: this.controller.signal});
      const sync = () => {
        const variant = mainFor(this)?.current;
        if (variant && String(variant.id) !== this.dataset.variantId) this.update(variant.id);
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, {once: true, signal: this.controller.signal}); else sync();
    }
    disconnectedCallback() { this.controller?.abort(); this.request?.abort(); this.sequence++; }
    async update(id) {
      id = id ? String(id) : '';
      this.requestedId = id;
      const sequence = ++this.sequence;
      this.request?.abort();
      this.retry.hidden = true;
      this.body.style.minHeight = '';
      this.style.minHeight = `${this.getBoundingClientRect().height}px`;
      this.body.hidden = true;
      this.setAttribute('aria-busy', 'true');
      this.status.textContent = this.labels.loading;
      this.status.hidden = false;
      try {
        if (!id) throw new Error('No selected variant');
        let content = this.cache.get(id);
        if (!content) {
          this.request = new AbortController();
          const url = new URL(location.href);
          url.hash = '';
          url.searchParams.delete('section_id');
          url.searchParams.delete('sections');
          url.searchParams.delete('option_values');
          url.searchParams.set('sections', this.dataset.sectionId);
          url.searchParams.set('variant', id);
          const response = await fetch(url, {signal: this.request.signal, credentials: 'same-origin'});
          if (!response.ok) throw new Error('Section request failed');
          const data = await response.json();
          if (typeof data[this.dataset.sectionId] !== 'string') throw new Error('Missing section');
          const doc = new DOMParser().parseFromString(data[this.dataset.sectionId], 'text/html');
          const element = doc.querySelector('maxler-protein-nutrition');
          if (element?.dataset.productId !== this.dataset.productId || element.dataset.variantId !== id) throw new Error('Variant identity mismatch');
          content = element.querySelector('[data-nutrition-body]').innerHTML;
          this.cache.set(id, content);
          if (this.cache.size > 12) this.cache.delete(this.cache.keys().next().value);
        }
        if (sequence !== this.sequence || this.controller.signal.aborted) return;
        const open = [...this.body.querySelectorAll('details')].map(detail => detail.open);
        this.body.innerHTML = content;
        [...this.body.querySelectorAll('details')].forEach((detail, index) => { detail.open = open[index] || false; });
        this.dataset.variantId = id;
        this.body.hidden = false;
        this.status.hidden = true;
        this.style.minHeight = '';
      } catch (error) {
        if (sequence !== this.sequence || this.controller.signal.aborted || error.name === 'AbortError') return;
        this.status.textContent = this.labels.error;
        this.retry.hidden = !id;
      } finally {
        if (sequence === this.sequence && !this.controller.signal.aborted) this.removeAttribute('aria-busy');
      }
    }
  });
})();
